import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { Categories } from "@/components/home/Categories";
import { WhyUs } from "@/components/home/WhyUs";
import { FeaturedProducts } from "@/components/home/FeaturedProducts";
import { AboutStory } from "@/components/home/AboutStory";
import { Partners } from "@/components/home/Partners";
import { PhotoBand } from "@/components/home/PhotoBand";
import { SupportCTA } from "@/components/home/SupportCTA";
import { Marquee } from "@/components/site/Marquee";
import { IMG } from "@/data/images";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  const { t, isRtl } = useLang();
  useSeo({
    title: isRtl
      ? "شركة الأبرد | لقاحات الدواجن والأدوية البيطرية في العراق"
      : "Al-Abrad | Poultry Vaccines & Veterinary Supplies in Iraq",
    description: isRtl
      ? "الأبرد تستورد وتوزّع لقاحات الدواجن والأدوية البيطرية والمكمّلات الغذائية المعتمدة في عموم العراق ضمن سلسلة تبريد غير منقطعة."
      : "Al-Abrad imports and distributes certified poultry vaccines, veterinary medicines and feed supplements across Iraq through an unbroken cold chain.",
  });

  const marqueeItems = isRtl
    ? ["نيوكاسل", "الغامبورو", "التهاب الشعب المعدي", "سلسلة تبريد", "تغطية وطنية", "مصادر معتمدة"]
    : ["Newcastle", "Gumboro", "Infectious Bronchitis", "Cold Chain", "Nationwide Iraq", "Certified Sources"];

  return (
    <>
      <Hero />
      <TrustBar />
      <Categories />
      <WhyUs />
      {/* No CTA on this band — the About page it pointed at repeats the same
          story, so the button was sending people in a circle. */}
      <PhotoBand
        testId="band-cold-chain"
        img={IMG.freeRange}
        kicker={t.bandA.kicker}
        title={t.bandA.title}
        sub={t.bandA.sub}
      />
      <FeaturedProducts />
      <Marquee items={marqueeItems} />
      <AboutStory />
      <PhotoBand
        testId="band-support"
        img={IMG.eggTrays}
        kicker={t.bandB.kicker}
        title={t.bandB.title}
        sub={t.bandB.sub}
        cta={t.bandB.cta}
        to="/support"
        align="center"
      />
      <Partners />
      <SupportCTA />
    </>
  );
}
